import { AdvancedSearchEntityType } from "generated/graphql";

export const templatePlaceholderTypes = [
    AdvancedSearchEntityType.Client,
    AdvancedSearchEntityType.Community,
    AdvancedSearchEntityType.ReferenceContact,
    AdvancedSearchEntityType.ReferenceBusiness,
];
